<div class="wrap">
  <ng-container [ngSwitch]="currentStep">
    <ng-container *ngSwitchCase="1">
      <h1 [innerHTML]="'TEAM_BECOME_MEMBER.TITLE_1' | translate"></h1>
      <p class="description">{{'TEAM_BECOME_MEMBER.DESCRIPTION_1' | translate}}</p>
    </ng-container>
    <ng-container *ngSwitchCase="2">
      <h1 [innerHTML]="'TEAM_BECOME_MEMBER.TITLE_2' | translate"></h1>
      <p class="description">{{'TEAM_BECOME_MEMBER.DESCRIPTION_2' | translate}}</p>
    </ng-container>
    <ng-container *ngSwitchCase="3">
      <h1 [innerHTML]="'TEAM_BECOME_MEMBER.TITLE_3' | translate"></h1>
      <p class="description">{{'TEAM_BECOME_MEMBER.DESCRIPTION_3' | translate}}</p>
    </ng-container>
    <ng-container *ngSwitchCase="4">
      <h1 [innerHTML]="'TEAM_BECOME_MEMBER.TITLE_4' | translate"></h1>
      <p class="description">{{'TEAM_BECOME_MEMBER.DESCRIPTION_4' | translate}}</p>
    </ng-container>
  </ng-container>


</div>
